import moment from 'moment';

export { default as generateChartData } from './generateChartData';
export { default as generateDomains } from './generateDomains';
export * from './generateDatePeriod';
export const xTickFormatter = (time: number) => moment.unix(time).format('H');
